import React from "react";
import { Link } from "react-router-dom";
import { Bird, LogOut, RefreshCw } from "lucide-react";

const AdminHeader = ({ onRefresh, onSignOut, refreshing }) => (
  <header className="bg-[#354556] text-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 border border-white/20">
          <Bird className="h-5 w-5 text-[#cfe7f8]" />
        </span>
        <span className="ht-display text-lg">Never Alone SG · Admin</span>
      </Link>
      <div className="flex items-center gap-3">
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="ht-btn inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/15 border border-white/15 px-4 py-2 text-sm disabled:opacity-60"
        >
          <RefreshCw
            className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`}
          />
          Refresh
        </button>
        <button
          onClick={onSignOut}
          className="ht-btn inline-flex items-center gap-2 rounded-full bg-[#cfe7f8] text-[#2c3e50] px-4 py-2 text-sm font-semibold"
        >
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>
    </div>
  </header>
);

export default AdminHeader;
